import { FC, Suspense, lazy } from 'react';
import { graphql, useFragment } from 'react-relay';

import { PdpRespMarketplacePersonalizedCarouselLoading } from './PdpRespMarketplacePersonalizedCarouselLoading';

import { PdpRespMarketplacePersonalizedCarouselLazy_viewer$key } from './__generated__/PdpRespMarketplacePersonalizedCarouselLazy_viewer.graphql';
import { PdpRespMarketplacePersonalizedCarouselLazy_user$key } from './__generated__/PdpRespMarketplacePersonalizedCarouselLazy_user.graphql';
import { useServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext';
import { useSbSelector } from '../../../reducers/useSbSelector';

export const PdpSharedPersonalizationCarousel = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpSharedPersonalizationCarousel" */ '../../shared/PdpSharedPersonalizationCarousel/PdpSharedPersonalizationCarousel'
        )
);

type Props = {
    viewer: PdpRespMarketplacePersonalizedCarouselLazy_viewer$key;
    user: PdpRespMarketplacePersonalizedCarouselLazy_user$key;
    currency: string;
    isClient: boolean;
};

const viewerFragment = graphql`
    fragment PdpRespMarketplacePersonalizedCarouselLazy_viewer on Viewer {
        ...PdpSharedPersonalizationCarousel_viewer @include(if: $isClient)
    }
`;

const userFragment = graphql`
    fragment PdpRespMarketplacePersonalizedCarouselLazy_user on User {
        ...PdpSharedPersonalizationCarousel_user @include(if: $isClient)
    }
`;

export const PdpRespMarketplacePersonalizedCarouselLazy: FC<Props> = ({
    viewer: viewerRef,
    user: userRef,
    currency,
}) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const user = useFragment(userFragment, userRef);
    const { isBot } = useServerVarsContext();
    const { afterDisplay } = useSbSelector(state => state.relayVariables?.variables);

    if (isBot) {
        return null;
    }

    if (!afterDisplay) {
        return <PdpRespMarketplacePersonalizedCarouselLoading />;
    }

    return (
        <Suspense fallback={<PdpRespMarketplacePersonalizedCarouselLoading />}>
            <PdpSharedPersonalizationCarousel viewer={viewer} user={user} currency={currency} />
        </Suspense>
    );
};
